<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="代码类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['codeType']" :trigger-change="true" dictCode="code_type" placeholder="请选择代码类型"/>
        </a-form-item>
        <a-form-item label="作业名" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['workName']" placeholder="请输入作业名"></a-input>
        </a-form-item>
        <a-form-item label="作业描述" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea v-decorator="['workDesc']" rows="4" placeholder="请输入作业描述"/>
        </a-form-item>
        <a-form-item label="作业封面" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-upload v-decorator="['workCover']" :uploadTarget="'qiniu'" :number="1" :fileType="'image'" :trigger-change="true"></j-upload>
        </a-form-item>
        <a-form-item label="作业文件" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-upload v-decorator="['workUrl']" :uploadTarget="'qiniu'" :number="1" :trigger-change="true"></j-upload>
        </a-form-item>
        <a-form-item label="分配班级" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-select-depart :multi="true" :onlyMyDepart="true" :onlyLeaf="true" :onlyCategory="3" :rootOpened="true" v-decorator="['workDept']"/>
        </a-form-item>
        <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="radio" v-decorator="['status']" :trigger-change="true" dictCode="additional_work_status" placeholder="请选择状态"/>
        </a-form-item>
        <!-- <a-form-item label="作业积分" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="['workIntegral']" placeholder="请输入本作业可获得积分" style="width: 100%"/>
        </a-form-item> -->

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import JUpload from '@/components/jeecg/JUpload'
  import JDictSelectTag from '@/components/jeecg/JDictSelectTag'
  import JSelectDepart from '@/components/jeecg/JSelectDepart'


  export default {
    name: "TeachingAdditionalWorkModal",
    components: { 
      JUpload,
      JSelectDepart,
      JDictSelectTag
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          add: "/teaching/teachingAdditionalWork/add",
          edit: "/teaching/teachingAdditionalWork/edit",
        }
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'codeType','createTime','workName','workDesc','workCover','workUrl','workDept','workIntegral','status'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'codeType', 'createTime','workName','workDesc','workCover','workUrl','workDept','workIntegral','status'))
      },

      
    }
  }
</script>